import type { Info } from '@/api/domains/info.types';

export const formatOptionsText = (option: Info) => `${option.name} - ${option.description}`;

export const isFormFilled = (neededFormValues: Record<string, unknown> | undefined) =>
  neededFormValues && Object.values(neededFormValues).some(value => value);
